import {
	ClientListPage,
	ProfilePage,
	AddUser,
	UpdateUser,
	UserDetails,
	CategoryPage,
	ProductPage,
	AddProduct,
	ProductDetails,
	DeliveryPage,
	DeliveryDetail,
	OrdersPage,
	OrderDetail,
	UpdateOrder,
	BillPage,
	BillDetails,
	ComplaintsPage,
	ComplainDetails,
	UpdateProduct,
	PaymentDetails,
	AddOrder,
  Dashboard,
  CompanyProfile,
  FinancementList,
  FacturePage,
  FactureDetails,
  CreateFactureProforma
} from '../pages/admin';
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import NotFound from './../pages/NotFound';

const AdminRoutes = () => {
	return (
		<Routes>
			<Route exact path='/' element={<CompanyProfile />} />
			<Route exact path='/admin/profile' element={<ProfilePage />} />
			<Route exact path='/admin/categories/:page' element={<CategoryPage />} />
			<Route exact path='/admin/products/:page' element={<ProductPage />} />
			<Route exact path='/admin/products/add_product/:page' element={<AddProduct />} />
			<Route exact path='/admin/products/product_update/:page/:id' element={<UpdateProduct />} />
			<Route exact path='/admin/products/product_details/:page/:id' element={<ProductDetails />} />
			<Route exact path='/admin/users/:page' element={<ClientListPage />} />
			<Route exact path='/admin/users/add_user/:page' element={<AddUser />} />
			<Route exact path='/admin/users/update_user/:page/:id' element={<UpdateUser />} />
			<Route exact path='/admin/users/user_details/:page/:id' element={<UserDetails />} />
			<Route exact path='/admin/orders/:page' element={<OrdersPage />} />
			<Route exact path='/admin/orders/order_details/:page/:id' element={<OrderDetail />} />
			<Route exact path='/admin/orders/order_add/:page/:companyId' element={<AddOrder />} />
			<Route exact path='/admin/orders/order_update/:page/:id' element={<UpdateOrder />} />
			<Route exact path='/admin/deliveries/:page' element={<DeliveryPage />} />
      <Route exact path='/admin/dashboard' element={<Dashboard />} />
      <Route exact path='/admin/companyProfile' element={<CompanyProfile />} />
      <Route exact path='/admin/createFacture' element={<CreateFactureProforma />} />
      <Route exact path='/admin/financements/:page' element={<FinancementList />} />
			<Route
				exact
				path='/admin/deliveries/delivery_details/:page/:id'
				element={<DeliveryDetail />}
			/>

			<Route
				exact
				path='/admin/deliveries/payment_details/:delivery_id'
				element={<PaymentDetails />}
			/>
			<Route exact path='/admin/bills/:page' element={<BillPage />} />
      <Route exact path='/admin/facture/:page' element={<FacturePage />} />
			<Route exact path='/admin/bills/bill_details/:page/:id' element={<BillDetails />} />
			<Route exact path='/admin/complaints/:page' element={<ComplaintsPage />} />
      <Route exact path='/admin/facture/:page/:id' element={<FactureDetails />} />
			<Route
				exact
				path='/admin/complaints/complain_details/:page/:id'
				element={<ComplainDetails />}
			/>
			<Route exact path='*' element={<NotFound />} />
		</Routes>
	);
};

export default AdminRoutes;
